import { render, staticRenderFns } from "./CardTarjaGE.vue?vue&type=template&id=cb36e4dc&scoped=true"
import script from "./CardTarjaGE.vue?vue&type=script&lang=js"
export * from "./CardTarjaGE.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaGE.vue?vue&type=style&index=0&id=cb36e4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb36e4dc",
  null
  
)

export default component.exports